import dayjs from 'dayjs';
import React, { FC } from 'react';
import { connect } from 'react-redux';

import ComposeMetaDateDue from '../../../components/Compose/Common/ComposeMeta/ComposeMetaDateDue';
import DueDate from '../../../components/MUI/Compose/DueDate';

import MetaDateDue from '../../../components/MetaDateDue';
import useComposeType from '../../../hooks/router/search/useComposeType';
import useIsMobile from '../../../hooks/useIsMobile';
import { ComposeModeParam } from '../../../models/pageParams';
import useComposeLinking from '../hooks/useComposeLinking';

import { mapDispatchToProps, mapStateToProps } from './redux';
import { Props } from './types';

/**
 * Setting and removing due date in compose form
 *
 * @param props                         Props passed to the container
 * @param props.dataDateDueCurrent      Currently selected due date
 * @param props.dataDateDueSaved        Saved due date
 * @param props.dataRemindersCurrent    Currently created reminders
 * @param props.dataRemindersSaved      Saved reminders
 * @param props.requestDateDueRemove    Request that the due date is cleared
 * @param props.requestDateDueSaveNew   Request that the due date is saved
 * @param props.requestRemindersRemove  Request that one reminder is removed
 * @param props.requestRemindersSaveNew Request that the reminders are saved
 * @returns                             The container itself
 */
const ComposeMetaDueDateContainer: FC<Props> = ({
  dataDateDueCurrent,
  dataDateDueSaved,
  dataRemindersCurrent,
  dataRemindersSaved,
  requestDateDueRemove,
  requestDateDueSaveNew,
  requestRemindersRemove,
  requestRemindersSaveNew,
}) => {
  const dateMin = new Date();
  const mode: ComposeModeParam = 'date';
  const { isActive, linkToggleProps } = useComposeLinking(mode);
  const composeType = useComposeType();

  // Due date should not be available for posts, only for tasks
  if (composeType === 'post') {
    return;
  }

  const isMobile = useIsMobile();
  const dueDate = (
    <DueDate
      dataDateDueMin={dayjs(dateMin)}
      dataDateDueSaved={dataDateDueSaved ? dayjs(dataDateDueSaved) : null}
      dataRemindersSaved={dataRemindersSaved}
      requestDateDueRemove={requestDateDueRemove}
      requestDateDueSave={requestDateDueSaveNew}
      requestRemindersSave={requestRemindersSaveNew}
    />
  );

  if (isMobile) {
    return (
      <MetaDateDue
        dataDateDueCurrent={dataDateDueCurrent}
        dataDateDueSaved={dataDateDueSaved}
        dataRemindersCurrent={dataRemindersCurrent}
        dataRemindersSaved={dataRemindersSaved}
        inputCustom={<ComposeMetaDateDue date={dataDateDueSaved?.toString()} />}
        isActive={isActive}
        linkToggleProps={linkToggleProps}
        requestDateDueRemove={requestDateDueRemove}
        requestRemindersRemove={requestRemindersRemove}
      >
        {dueDate}
      </MetaDateDue>
    );
  }

  return dueDate;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ComposeMetaDueDateContainer);
